/**
 * @format
 */

import { gql } from '@apollo/client';

// Agent Leaderboard Query
export const GET_LEADERBOARD = gql`
  query GetAgentLeaderboard($filter: AgentLeaderboardFilterInput) {
    getLeaderboard(filter: $filter) {
      userId
      totalMajorMed
      totalMajorMedPremium
      totalPrivateMed
      totalPrivateMedPremium
      totalAncillary
      totalAncillaryPremium
      totalCalls
      totalBillable
      totalCost
      user {
        _id
        firstName
        lastName
        email
      }
    }
  }
`;

// Weekly Leaderboard Query
export const GET_WEEKLY_LEADERBOARD = gql`
  query GetWeeklyLeaderboard($filter: WeeklyLeaderboardFilterInput) {
    getWeeklyLeaderboard(filter: $filter) {
      dayOfWeek
      userId
      totalMajorMed
      totalPrivateMed
      totalAncillaries
      totalPremium
      user {
        _id
        firstName
        lastName
        email
      }
    }
  }
`;

// Type Definitions
export interface LeaderboardUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface AgentLeaderboardItem {
  userId: string;
  totalMajorMed: number;
  totalMajorMedPremium: number;
  totalPrivateMed: number;
  totalPrivateMedPremium: number;
  totalAncillary: number;
  totalAncillaryPremium: number;
  totalCalls: number;
  totalBillable: number;
  totalCost: number;
  user: LeaderboardUser;
}

export interface WeeklyLeaderboardItem {
  dayOfWeek: number;
  userId: string;
  totalMajorMed: number;
  totalPrivateMed: number;
  totalAncillaries: number;
  totalPremium: number;
  user?: LeaderboardUser;
}

export interface UserWeeklySalesItem {
  dayOfWeek: number;
  totalSales: number;
  totalPremium: number;
  totalLeads: number;
  totalCost: number;
}

export interface AgentLeaderboardFilterInput {
  officeId?: string;
  customerId?: string;
  userId?: string;
  startDate?: string;
  endDate?: string;
  isPostDate?: boolean;
  request?: boolean;
  status?: string;
}

export interface WeeklyLeaderboardFilterInput {
  officeId?: string;
}
